'use strict';
import { Col, Layout, Row } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { logout } from '../../../containers/Login/actions';
import { hasFeature } from '../../features';
import env from '../../constants/environment';
import AsyncPoll from '../../../containers/AsyncPoll';
import FeatureFlags from '../../../containers/FeatureFlags';
import ProfileSaver from '../../../containers/Login/ProfileSaver';
import Sidebar from '../Sidebar';
import VersionChecker from '../../../containers/VersionChecker';
import TagManager from 'react-gtm-module';
import LazyLoad from 'react-lazyload';
import { selectEventTypeFilter } from '../../../containers/ChooseRace/actions';
const { Content, Footer } = Layout;
var backgroundStyle = {
	background: 'no-repeat 70% center',
	overflow: 'auto',
	backgroundSize: 'auto 85%',
	opacity: '1',
	height: '100%'
}

class MainLayout extends React.Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		//GM: Temporary location while fixing how this works.
		this.logPageView(window.location.pathname);
	}

	logPageView(pathname) {
		const tagManagerArgs = {
			dataLayer: {
				event: 'pageView',
				page: pathname
			}
		};
		TagManager.dataLayer(tagManagerArgs);
	}

	render() {
		const { profile } = this.props.user;
		return (
			<div>
				<Sidebar
					featureGroups={this.props.featureGroups}
					logout={this.props.logout}
					selectEventTypeFilter={selectEventTypeFilter}
					{...this.props}
				/>
				<Content className="main-body">
					<div>
						<AsyncPoll />
						<VersionChecker />
						<FeatureFlags />
						<ProfileSaver />
						{this.props.children}
					</div>
				</Content>
				<Footer style={{ textAlign: 'center' }}>
					<Row>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className="footer-social-container"
						>
							<div className="footer-social-container-inner">
								<Col className="footer-social-icons-column">
									<a href='https://twitter.com/Yesfit1' title="Go to Yes.Fit Twitter Page" className="social-ada-focus">
										<LazyLoad>
											<img alt="Yes.Fit Twitter Page" title="Go to Yes.Fit Twitter Page" src="https://asset.yes.fit/homepage/social-twitter-compressed.png" className="footer-social-icon" />
										</LazyLoad>
									</a>
								</Col>
								<Col>
									<a href='https://www.facebook.com/YesFit/' title="Go to Yes.Fit Facebook Page" className="social-ada-focus">
										<LazyLoad>
											<img alt="Yes.Fit Facebook Page" title="Go to Yes.Fit Facebook Page" src="https://asset.yes.fit/homepage/social-facebook-compressed.png" className="footer-social-icon" />
										</LazyLoad>
									</a>
								</Col>
								<Col>
									<a href='https://www.instagram.com/yesfitchallenges/' title="Go to Yes.Fit Instagram Page" className="social-ada-focus">
										<LazyLoad>
											<img alt="Yes.Fit Instagram Page" title="Go to Yes.Fit Instagram Page" src="https://asset.yes.fit/homepage/social-instagram-compressed.png" className="footer-social-icon" />
										</LazyLoad>
									</a>
								</Col>
								<Col>
									<a href='https://blog.yes.fit/' title="Go to Yes.Fit Blog Page" className="social-ada-focus">
										<LazyLoad>
											<img alt="Yes.Fit Blog Page" title="Go to Yes.Fit Blog Page"  src="https://asset.yes.fit/homepage/social-blog-compressed.png" className="footer-social-icon" />
										</LazyLoad>
									</a>
								</Col>
							</div>
						</Col>
					</Row>
					Yes.Fit ©{new Date().getFullYear()} | v{env.VERSION} | <Link to='/terms' className='ada-focus'>Terms &amp; Privacy</Link>
				</Footer>
			</div>
		);
	}
}

function bindAction(dispatch) {
	return {
		logout: () => dispatch(logout()),
		selectEventTypeFilter: (value) => dispatch(selectEventTypeFilter(value))
	};
}

function mapStateToProps(state) {
	return {
		user: state.user,
		featureGroups: hasFeature('groups', state.user)
	};
}

export default connect(mapStateToProps, bindAction, null, {pure: true})(MainLayout);
